import { useEffect, useState } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { openModal } from 'helpers/dom'
import CustomModalDialog from 'snippets/custom-modal-dialog/custom-modal-dialog'
import QuoteForm from 'snippets/quote/quote-form'

const selectors = {
  QUOTE_MODAL_ID: 'modal-quote',
  MINI_CART_MODAL_ID: 'MiniCart'
}

function QuoteModal() {
  const [type, setType] = useState('product')

  useEffect(() => {
    globalEmitter.on(emitterProps.quote.create, (value) => {
      setType(value.type)
      openModal(selectors.QUOTE_MODAL_ID)
    })
  }, [])

  return (
    <CustomModalDialog
      id={selectors.QUOTE_MODAL_ID}
      classHeader="!static"
      header={<p className="h6 text-center mb-4 lg:h4">{type === 'product' ? translate.product.getQuote : translate.cart.create_quote_from_cart}</p>}
      content={<QuoteForm id={selectors.QUOTE_MODAL_ID} type={type} />}
      classMain="px-5 py-6 w-full max-w-[560px] rounded-lg outline-none overflow-auto scrollbar-hidden h-full max-h-[720px] lg-max:mx-4 lg:p-12 lg:max-h-[746px]"
      classClose="absolute size-5 !top-4 !right-4 z-10 !p-0 lg:size-6"
      classIcon="size-6 text-grey-900"
      scrollTarget=".modal-dialog-content"
    />
  )
}

export default QuoteModal
